import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { NavLink, useLocation } from "react-router-dom";

const TabItem = ({ href, icons, label }) => {
  const location = useLocation();

  const handleClick = (e) => {
    // 현재 경로와 클릭한 경로가 같으면 이벤트를 취소
    if (location.pathname.includes(href)) {
      e.preventDefault();
      if (href === "/home") {
        const content = document.querySelector("#home-contents");
        if (content) {
          content.scrollTo({ top: 0, behavior: "smooth" });
        }
      } else {
        const content = document.querySelector("#content");
        if (content) {
          content.scrollTo({ top: 0, behavior: "smooth" });
        }
      }
    }
  };

  return (
    <TabItemWrapper>
      <NavLink
        to={href}
        className={({ isActive }) => (isActive ? "focus" : "")}
        onClick={handleClick}
      >
        <img src={icons.default} alt="" />
        <img src={icons.active} alt="" />
        <div>{label}</div>
        {label === "리포트" && (
          <NewIcon>
            <svg
              width="31"
              height="18"
              viewBox="0 0 31 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="0.600006"
                width="30"
                height="18"
                rx="9"
                fill="url(#paint0_linear_18021_42)"
              />
              <path
                d="M20.0015 12.1823H18.7086L16.8906 5.81769H18.3326L19.3986 10.2711H19.4545L20.623 5.81769H21.8661L23.0346 10.2773H23.0874L24.1534 5.81769H25.5954L23.7774 12.1823H22.4876L21.2694 7.98378H21.2197L20.0015 12.1823Z"
                fill="white"
              />
              <path
                d="M16.2679 12.1823H11.9855V5.81769H16.2555V6.91161H13.3063V8.45305H16.0349V9.54386H13.3063V11.0884H16.2679V12.1823Z"
                fill="white"
              />
              <path
                d="M9.59807 5.81769H10.9126V12.1823H9.76899L6.97203 8.13917H6.92542V12.1823H5.60463V5.81769H6.76692L9.54213 9.85774H9.59807V5.81769Z"
                fill="white"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_18021_42"
                  x1="5.60001"
                  y1="4.5"
                  x2="41.6232"
                  y2="19.4105"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FF426F" />
                  <stop offset="1" stopColor="#FFCB47" />
                </linearGradient>
              </defs>
            </svg>
          </NewIcon>
        )}
      </NavLink>
    </TabItemWrapper>
  );
};

// note : if use Styled NavLink, 'isActive' is not working.

const NewIcon = styled.span`
  position: absolute;
  top: 4px;
  right: 12px;
`;

const TabItemWrapper = styled.div`
  position: relative;
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  height: 100%;
  line-height: 1.2;
  letter-spacing: -0.4px;
  text-align: center;
  font-size: 12px;
  color: #b2bfd1;
  box-shadow: none;

  a {
    padding: 2px;
    width: 60px;
    text-decoration: none;
    font-weight: 600;
    color: inherit;
    transition: color 0.4s;
  }
  a:hover {
    color: inherit;
    box-shadow: none;
  }
  a.focus {
    color: #004fec;
    box-shadow: none;
  }
  a div {
    margin-top: 4px;
  }
  a img {
    margin: 1px auto;
  }
  a img + img,
  a.focus img:first-child {
    display: none;
  }
  a.focus img + img {
    display: block;
  }
`;

TabItem.propTypes = {
  href: PropTypes.string,
  icons: PropTypes.any,
  label: PropTypes.string,
};

export default TabItem;
